const { createContext, useState, useEffect } = React;
const api = window.api;

const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(api?.getAuthToken ? api.getAuthToken() : null);
  const [loading, setLoading] = useState(false);

  const refreshProfile = async () => {
    const profile = await api.request("/auth/profile");
    setUser(profile.data || null);
    return profile;
  };

  useEffect(() => {
    if (token) {
      api.setAuthToken(token);
      // Optionally fetch profile
      (async () => {
        try {
          await refreshProfile();
        } catch (err) {
          console.error(err);
          api.setAuthToken(null);
          setToken(null);
          setUser(null);
        }
      })();
    }
  }, [token]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const res = await api.apiLogin({ email, password });
      api.setAuthToken(res.data.token);
      setToken(res.data.token);
      await refreshProfile();
    } finally {
      setLoading(false);
    }
  };

  const register = async data => {
    setLoading(true);
    try {
      const res = await api.apiRegister(data);
      api.setAuthToken(res.data.token);
      setToken(res.data.token);
      await refreshProfile();
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    api.apiLogout();
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, refreshProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

// expose for global usage
export { AuthContext, AuthProvider };
window.AuthContext = AuthContext;
window.AuthProvider = AuthProvider;
